// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"78ad7c48","455":"11499277"}[chunkId] + ".chunk.js";
};